export const MerchandisingProgramAvailabilityEnumValue = {
  All: 0,

  Usa: 10,
  Can: 20,
};

export const MerchandisingProgramAvailabilityEnum = [
  {
    value: MerchandisingProgramAvailabilityEnumValue.All,
    labelFrench: 'Tous',
    labelEnglish: 'All',
  },
  {
    value: MerchandisingProgramAvailabilityEnumValue.Usa,
    labelFrench: 'Usa',
    labelEnglish: 'Usa',
  },
  {
    value: MerchandisingProgramAvailabilityEnumValue.Can,
    labelFrench: 'Canada',
    labelEnglish: 'Canada',
  },
];

export default MerchandisingProgramAvailabilityEnum;
